<template>
                      <h2 class="titleStepForm">
                        Foreign Account Tax Compliance ACT <sup>(FATCA)</sup>
                      </h2>
                      <div class="">
                        <div class="mb-3 border-bottom pb-3">
                          <h3 class="font-size-16">
                            Are you a citizen of any country other than Trinidad
                            and Tobago?
                          </h3>
                          <p class="mb-0">
                            <strong
                              class="font-size-13 font-weight-500 text-warning"
                              >REQUIREMENTS:</strong
                            >
                            If yes, copies of relevant passport(s) to be provided.
                          </p>
                          <div>
                            <!-- Tobago Radio Buttons -->
                            <div class="row">
                              <!-- Yes Radio Button -->
                              <div class="col-auto">
                                <label
                                  for="yesTabago"
                                  class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal6.tobagoRadio.$error,
                                  }"
                                >
                                  <input
                                    type="radio"
                                    v-model="form.personal6.tobagoRadio"
                                    value="True"
                                    class="inputRadioCstm d-none"
                                    id="yesTabago"
                                  />
                                  <span class="radioCircleIcon">
                                    <i
                                      class="mdi mdi-circle-outline text-theme font-size-20"
                                    ></i>
                                    <i
                                      class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                    ></i>
                                  </span>
                                  <h4
                                    class="font-size-14 text-dark-custom mb-0 ms-1"
                                  >
                                    Yes
                                  </h4>
                                </label>
                              </div>

                              <!-- No Radio Button -->
                              <div class="col-auto">
                                <label
                                  for="noTabago"
                                  class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                  :class="{
                                    'is-invalid':
                                      v$.form.personal6.tobagoRadio.$error,
                                  }"
                                >
                                  <input
                                    type="radio"
                                    v-model="form.personal6.tobagoRadio"
                                    value="False"
                                    class="inputRadioCstm d-none"
                                    id="noTabago"
                                  />
                                  <span class="radioCircleIcon">
                                    <i
                                      class="mdi mdi-circle-outline text-theme font-size-20"
                                    ></i>
                                    <i
                                      class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                    ></i>
                                  </span>
                                  <h4
                                    class="font-size-14 text-dark-custom mb-0 ms-1"
                                  >
                                    No
                                  </h4>
                                </label>
                              </div>

  <div v-if="v$.form.personal6.tobagoRadio.$error" class="invalid-feedback d-block w-100"><span v-if="v$.form.personal6.tobagoRadio.$errors[0]">{{ v$.form.personal6.tobagoRadio.$errors[0].$message }}</span></div>
  </div>
                          </div>
                          <!-- File Field (shown when 'Yes' is selected) -->
                          <div
                            class="col-auto textareaShow"
                            v-if="form.personal6.tobagoRadio === 'True'"
                          >
                            <input
                              type="file"
                              accept=".docx, .doc, application/pdf,application/vnd.ms-excel/, image/jpg, image/png"
                              @change="previewImage($event, '4')"
                              class="form-control"
                              id="my-file"
                            />
                            <template v-if="preview[4]">
                              <div class="border bg-white p-2 mt-3">
                                <h4 class="font-size-15 mb-3">Bill Here:</h4>
                                <img
                                  v-if="
                                    preview[4].type === 'pdf' ||
                                    preview[4].type === 'docx' ||
                                    preview[4].type === 'xlsx'
                                  "
                                  src="@/assets/images/ECU/icon-file.png"
                                  alt="icon-image"
                                  class="icon-file-upload"
                                />
                                <img
                                  v-else
                                  :src="preview[4].value"
                                  class="img-custom-preview"
                                />
                                <p class="mb-0">file name: {{ image[4].name }}</p>
                                <p class="mb-0">
                                  size: {{ image[4].size / 1024 }}KB
                                </p>
                              </div>
                            </template>
                          </div>
                        </div>
                        <div class="mb-3 border-bottom pb-3">
                          <h3 class="font-size-16">
                            Are you a US Citizen, Resident or Green Card Holder?
                          </h3>
                          <p class="mb-0">
                            <strong
                              class="font-size-13 font-weight-500 text-warning"
                              >REQUIREMENTS:</strong
                            >
                            W-9 or W-8BEN , Document showing Immigration Status.
                          </p>
                          <div class="row mt-2 align-items-center">
                            <div class="col-md-4">
                              <div class="d-block">
                                <label class="font-size-14">SSN No</label>
                                <template
                                  v-if="
                                    form.personal6.citizenRadio === 'True' ||
                                    form.personal6.citizenRadio === ''
                                  "
                                >
                                  <input placeholder="Enter SSN number"
                                    type="number"
                                    v-model="form.personal6.ssn_no"
                                    class="form-control"
                                    @input="validateSSNNO"
                                    :class="{
                                      'is-invalid':
                                        v$.form.personal6.ssn_no.$error,
                                    }"
                                    :required="isSSNRequired"
                                  />
                                  <div
                                    v-for="(personal6, index) in v$.form.personal6
                                      .ssn_no.$errors"
                                    :key="index"
                                    class="invalid-feedback"
                                  >
                                    <span v-if="personal6.$message">{{
                                      personal6.$message
                                    }}</span>
                                  </div>
                                </template>
                                <template
                                  v-else-if="
                                    form.personal6.citizenRadio === 'False'
                                  "
                                >
                                  <input placeholder="Enter SSN number"
                                    type="number"
                                    v-model="form.personal6.ssn_no"
                                    class="form-control"
                                  />
                                </template>
                              </div>
                            </div>
                            <div class="col-auto">
                              <label
                                for="yesCitizen"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal6.citizenRadio.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal6.citizenRadio"
                                  value="True"
                                  class="inputRadioCstm d-none"
                                  id="yesCitizen"
                                />
                                <span class="radioCircleIcon">
                                  <i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i>
                                  <i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i>
                                </span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  Yes
                                </h4>
                              </label>
                            </div>
                            <div class="col-auto">
                              <label
                                for="noCitizen"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal6.citizenRadio.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal6.citizenRadio"
                                  value="False"
                                  class="inputRadioCstm d-none"
                                  id="noCitizen"
                                />
                                <span class="radioCircleIcon">
                                  <i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i>
                                  <i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i>
                                </span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  No
                                </h4>
                              </label>
                            </div>

  <div v-if="v$.form.personal6.citizenRadio.$error" class="invalid-feedback d-block w-100"><span v-if="v$.form.personal6.citizenRadio.$errors[0]">{{ v$.form.personal6.citizenRadio.$errors[0].$message }}</span></div>
  </div>
                          <!-- File Field (shown when 'Yes' is selected) -->
                          <div
                            class="col-auto textareaShow"
                            v-if="form.personal6.citizenRadio === 'True'"
                          >
                            <input
                              type="file"
                              accept=".docx, .doc, application/pdf,application/vnd.ms-excel/, image/jpg, image/png"
                              @change="previewImage($event, '5')"
                              class="form-control"
                              id="my-file"
                            />
                            <template v-if="preview[5]">
                              <div class="border bg-white p-2 mt-3">
                                <h4 class="font-size-15 mb-3">Bill Here:</h4>
                                <img
                                  v-if="
                                    preview[5].type === 'pdf' ||
                                    preview[5].type === 'docx' ||
                                    preview[5].type === 'xlsx'
                                  "
                                  src="@/assets/images/ECU/icon-file.png"
                                  alt="icon-image"
                                  class="icon-file-upload"
                                />
                                <img
                                  v-else
                                  :src="preview[5].value"
                                  class="img-custom-preview"
                                />
                                <p class="mb-0">file name: {{ image[5].name }}</p>
                                <p class="mb-0">
                                  size: {{ image[5].size / 1024 }}KB
                                </p>
                              </div>
                            </template>
                          </div>
                        </div>
                        <div class="mb-3 border-bottom pb-3">
                          <h3 class="font-size-16">Do you have a US address?</h3>
                          <p class="mb-0">
                            <strong
                              class="font-size-13 font-weight-500 text-warning"
                              >REQUIREMENTS:</strong
                            >
                            W-9 or W-8BEN
                          </p>
                          <div class="row">
                            <div class="col-auto">
                              <label
                                for="yesAddress"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal6.addressRadio.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal6.addressRadio"
                                  value="True"
                                  class="inputRadioCstm d-none"
                                  id="yesAddress"
                                />
                                <span class="radioCircleIcon">
                                  <i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i>
                                  <i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i>
                                </span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  Yes
                                </h4>
                              </label>
                            </div>
                            <div class="col-auto">
                              <label
                                for="noAddress"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal6.addressRadio.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal6.addressRadio"
                                  value="False"
                                  class="inputRadioCstm d-none"
                                  id="noAddress"
                                />
                                <span class="radioCircleIcon">
                                  <i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i>
                                  <i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i>
                                </span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  No
                                </h4>
                              </label>
                            </div>

  <div v-if="v$.form.personal6.addressRadio.$error" class="invalid-feedback d-block w-100"><span v-if="v$.form.personal6.addressRadio.$errors[0]">{{ v$.form.personal6.addressRadio.$errors[0].$message }}</span></div>
  </div>
                          <!-- File Field (shown when 'Yes' is selected) -->
                          <div
                            class="col-auto textareaShow"
                            v-if="form.personal6.addressRadio === 'True'"
                          >
                            <input
                              type="file"
                              accept=".docx, .doc, application/pdf,application/vnd.ms-excel/, image/jpg, image/png"
                              @change="previewImage($event, '6')"
                              class="form-control"
                              id="my-file"
                            />
                            <template v-if="preview[6]">
                              <div class="border bg-white p-2 mt-3">
                                <h4 class="font-size-15 mb-3">Bill Here:</h4>
                                <img
                                  v-if="
                                    preview[6].type === 'pdf' ||
                                    preview[6].type === 'docx' ||
                                    preview[6].type === 'xlsx'
                                  "
                                  src="@/assets/images/ECU/icon-file.png"
                                  alt="icon-image"
                                  class="icon-file-upload"
                                />
                                <img
                                  v-else
                                  :src="preview[6].value"
                                  class="img-custom-preview"
                                />
                                <p class="mb-0">file name: {{ image[6].name }}</p>
                                <p class="mb-0">
                                  size: {{ image[6].size / 1024 }}KB
                                </p>
                              </div>
                            </template>
                          </div>
                        </div>
                        <div class="mb-3 border-bottom pb-3">
                          <h3 class="font-size-16">
                            Are you giving instructions for the transfer of
                            dividends/ other income to a US Account?
                          </h3>
                          <p class="mb-0">
                            <strong
                              class="font-size-13 font-weight-500 text-warning"
                              >REQUIREMENTS:</strong
                            >
                            W-9 or W-8BEN
                          </p>
                          <div class="row">
                            <div class="col-auto">
                              <label
                                for="yesIncomeUs"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal6.incomeUsRadio.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal6.incomeUsRadio"
                                  value="True"
                                  class="inputRadioCstm d-none"
                                  id="yesIncomeUs"
                                />
                                <span class="radioCircleIcon">
                                  <i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i>
                                  <i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i>
                                </span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  Yes
                                </h4>
                              </label>
                            </div>
                            <div class="col-auto">
                              <label
                                for="noIncomeUs"
                                class="w-100 b-0 p-relative labelStyleRadioCstm pt-2 pb-2"
                                :class="{
                                  'is-invalid':
                                    v$.form.personal6.incomeUsRadio.$error,
                                }"
                              >
                                <input
                                  type="radio"
                                  v-model="form.personal6.incomeUsRadio"
                                  value="False"
                                  class="inputRadioCstm d-none"
                                  id="noIncomeUs"
                                />
                                <span class="radioCircleIcon">
                                  <i
                                    class="mdi mdi-circle-outline text-theme font-size-20"
                                  ></i>
                                  <i
                                    class="mdi mdi-checkbox-marked-circle text-theme theme-check font-size-20"
                                  ></i>
                                </span>
                                <h4
                                  class="font-size-14 text-dark-custom mb-0 ms-1"
                                >
                                  No
                                </h4>
                              </label>
                            </div>

  <div v-if="v$.form.personal6.incomeUsRadio.$error" class="invalid-feedback d-block w-100"><span v-if="v$.form.personal6.incomeUsRadio.$errors[0]">{{ v$.form.personal6.incomeUsRadio.$errors[0].$message }}</span></div>
  </div>
                          <!-- File Field (shown when 'Yes' is selected) -->
                          <div
                            class="col-auto textareaShow"
                            v-if="form.personal6.incomeUsRadio === 'True'"
                          >
                            <input
                              type="file"
                              accept=".docx, .doc, application/pdf,application/vnd.ms-excel/, image/jpg, image/png"
                              @change="previewImage($event, '7')"
                              class="form-control"
                              id="my-file"
                            />
                            <template v-if="preview[7]">
                              <div class="border bg-white p-2 mt-3">
                                <h4 class="font-size-15 mb-3">Bill Here:</h4>
                                <img
                                  v-if="
                                    preview[7].type === 'pdf' ||
                                    preview[7].type === 'docx' ||
                                    preview[7].type === 'xlsx'
                                  "
                                  src="@/assets/images/ECU/icon-file.png"
                                  alt="icon-image"
                                  class="icon-file-upload"
                                />
                                <img
                                  v-else
                                  :src="preview[7].value"
                                  class="img-custom-preview"
                                />
                                <p class="mb-0">file name: {{ image[7].name }}</p>
                                <p class="mb-0">
                                  size: {{ image[7].size / 1024 }}KB
                                </p>
                              </div>
                            </template>
                          </div>
                        </div>
                        <div class="pt-3">
                          <h4 class="text-center font-size-14 mb-0">
                            If you have answered “yes” to any of the questions
                            <template v-if="isEdit">
                            above, FATCA Documentation to be completed
                            <a
                              href="https://www.irs.gov/businesses/corporations/fatca-related-forms"
                              target="_blank"
                              >Click Here.</a
                            >
                            </template>
                            <template v-if="!isEdit">
                            above, FATCA Documentation to be completed.
                            <!-- Optional UI element -->
                            </template>
                          </h4>
                        </div>
                      </div>
</template>

<script>
import { bridge } from "../formBridge";

export default {
  name: "FatcaStep",
  props: {
    mode: { type: String, default: "create" },
  },
  computed: {
    isEdit() {
      return this.mode === "edit";
    },
  },
  mixins: [
    bridge({
    state: ["preview", "image", "form"],
    readonly: ["isSSNRequired"],
    methods: ["validateSSNNO", "previewImage"],
    validate: true,
    }),
  ],
};
</script>